import { useMemo } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import SetPasswordForm from '../_shared/SetPasswordForm';

export default function AcceptInvite() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  if (!token || token.length < 32) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-600 via-brand-700 to-brand-900 px-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <h1 className="text-lg font-semibold text-gray-900">Invalid invitation</h1>
          <p className="text-sm text-gray-500 mt-2">Open the full link from your invite email, or ask an admin to resend.</p>
          <Link to="/admin/login" className="inline-block mt-6 text-brand-600 hover:underline text-sm">Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-600 via-brand-700 to-brand-900 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white">Genesis Creations</h1>
          <p className="text-brand-200 mt-1">Talent Hub</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Set your password</h2>
          <p className="text-sm text-gray-500 mb-6">Complete your invitation to access the hub.</p>
          <SetPasswordForm
            token={token}
            endpoint="/auth/accept-invite"
            tokenKind="invite"
            submitLabel="Save and continue"
            successMessage="Password saved. You can sign in."
            redirectTo="/admin/login"
            timeout={15000}
            recovery={
              <span className="text-danger-700">
                Ask an admin to resend your invitation, then open the newest email.{' '}
                <Link to="/admin/login" className="font-medium text-danger-800 underline hover:text-danger-900">
                  Back to sign in
                </Link>
              </span>
            }
          />
        </div>

        <p className="text-center text-brand-300 text-sm mt-6">
          <Link to="/admin/login" className="text-white hover:underline">Sign in instead</Link>
        </p>
      </div>
    </div>
  );
}
